import { BusinessUnitShort, BusinessUnitDescribed } from '../@enums/businessUnit'

export const businessUnitCombined = {
  [BusinessUnitShort.BOT]: BusinessUnitDescribed.boticario,
  [BusinessUnitShort.EUD]: BusinessUnitDescribed.eudora,
  [BusinessUnitShort.EAM]: BusinessUnitDescribed.euamomake,
  [BusinessUnitShort.OUI]: BusinessUnitDescribed.oui,
}
